import { render, staticRenderFns } from "./market-analysis-performance-model.vue?vue&type=template&id=90165618&scoped=true&"
import script from "./market-analysis-performance-model.vue?vue&type=script&lang=js&"
export * from "./market-analysis-performance-model.vue?vue&type=script&lang=js&"
import style0 from "./market-analysis-performance-model.vue?vue&type=style&index=0&id=90165618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90165618",
  null
  
)

export default component.exports